import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';

interface PageBrain {
  Title?: string;
  [key: string]: unknown;
}

interface AcaoItem {
  label?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher a página no campo Link, herda o título como rótulo da ação.
 * Só preenche quando o rótulo está vazio (ver `Destaques/adapter.ts`).
 */
export const buildAcaoFields = (
  page: PageBrain,
  item: AcaoItem = {},
): Partial<AcaoItem> =>
  !item.label && page.Title ? { label: page.Title } : {};

export const AcoesRapidasBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  blockAdapterBase(
    block,
    data,
    id,
    onChangeBlock,
    value,
    'links',
    buildAcaoFields,
  );
};

export default AcoesRapidasBlockDataAdapter;
